import { Images } from "../../../Images";
import TileMinedLogic from "../../../logic/TileMinedLogic";
import { Settings } from "../../../Settings";
import DrillSkillRenderer from "../../../view/canvas/DrillSkillRenderer";
import SkillRenderer from "../../../view/canvas/SkillRenderer";
import PartyCharacter from "../../character/PartyCharacter";
import Crew from "../../crew/Crew";
import Totals from "../../crew/Totals";
import WorldGrid from "../../grid/WorldGrid";
import BigNum from "../../math/BigNum";
import GervaisAnimatedSpritesheet from "../../sprite/GervaisAnimatedSpritesheet";
import NumberValue from "../../value/NumberValue";
import AddMinerSkillNode from "../common/AddMInerSkillNode";
import CoolDownSkillNode from "../common/CoolDownSkillNode";
import DurationSkillNode from "../common/DurationSkillNode";
import TileRangeSkillNode from "../common/TileRangeSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";
import Drill from "./Drill";

export default class DrillSkill extends SkillType {
    /**
     * @param {WorldGrid} worldGrid 
     * @param {Totals} totals
     * @param {TileMinedLogic} tileMinedLogic 
     * @param {Crew} crew
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet
     */
    constructor(worldGrid, totals, tileMinedLogic, crew, spellFxSpritesheet) {
        super(SkillIds.DRILL);
        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;
        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {Crew}
         */
        this.crew = crew;

        /**
         * @constant
         * @type {Drill[]}
         */
        this.drillArray = [];

        /**
         * @constant
         * @type {Object}
         */
        this.drillByCharacter = {};

        /**
         * @constant
         * @type {NumberValue}
         */
        this.depthUpgrades = new NumberValue(null, 0);


        /**
         * @constant
         * @type {SkillRenderer}
         */
        this.renderer = new DrillSkillRenderer(this.drillArray, spellFxSpritesheet);

        let cost = 1;

        const addMinerNode1 = this.addNode(new AddMinerSkillNode('addDrillMiner1', '+1 Drill Miner', 'Drills straight down', 
            totals, Images.skill.drill, new BigNum(cost + Settings.skill.costs.addDrill1), this, crew, SkillIds.DRILL
        ));

        
        ////////////////////////////
        // Cost Tier 2
        ////////////////////////////

        cost++;

        const drillDepth1 = this.addNode(new TileRangeSkillNode('drillDepth1', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus1 = this.addNode(new CoolDownSkillNode('drillCool1', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus1 = this.addNode(new DurationSkillNode('drillDur1', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 3
        ////////////////////////////
        
        cost++;

        const drillDepth2 = this.addNode(new TileRangeSkillNode('drillDepth2', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus2 = this.addNode(new CoolDownSkillNode('drillCool2', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus2 = this.addNode(new DurationSkillNode('drillDur2', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 4
        ////////////////////////////
        
        cost++;

        const drillDepth3 = this.addNode(new TileRangeSkillNode('drillDepth3', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));
    
        const coolBonus3 = this.addNode(new CoolDownSkillNode('drillCool3', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus3 = this.addNode(new DurationSkillNode('drillDur3', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        const addMinerNode2 = this.addNode(new AddMinerSkillNode('addDrillMiner2', '+1 Drill Miner', 'Drills straight down', 
            totals, Images.skill.drill, new BigNum(cost + Settings.skill.costs.addMiner2), this, crew, SkillIds.DRILL
        ));


        ////////////////////////////
        // Cost Tier 5
        ////////////////////////////
        
        cost++;

        const drillDepth4 = this.addNode(new TileRangeSkillNode('drillDepth4', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus4 = this.addNode(new CoolDownSkillNode('drillCool4', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus4 = this.addNode(new DurationSkillNode('drillDur4', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 6
        ////////////////////////////
        
        cost++;

        const drillDepth5 = this.addNode(new TileRangeSkillNode('drillDepth5', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus5 = this.addNode(new CoolDownSkillNode('drillCool5', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus5 = this.addNode(new DurationSkillNode('drillDur5', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 7
        ////////////////////////////
        
        cost++;

        const drillDepth6 = this.addNode(new TileRangeSkillNode('drillDepth6', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus6 = this.addNode(new CoolDownSkillNode('drillCool6', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus6 = this.addNode(new DurationSkillNode('drillDur6', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        const addMinerNode3 = this.addNode(new AddMinerSkillNode('addDrillMiner3', '+1 Drill Miner', 'Drills straight down', 
            totals, Images.skill.drill, new BigNum(cost + Settings.skill.costs.addMiner3), this, crew, SkillIds.DRILL
        ));

        ////////////////////////////
        // Cost Tier 8
        ////////////////////////////
        
        cost++;

        const drillDepth7 = this.addNode(new TileRangeSkillNode('drillDepth7', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus7 = this.addNode(new CoolDownSkillNode('drillCool7', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus7 = this.addNode(new DurationSkillNode('drillDur7', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));
        
        ////////////////////////////
        // Cost Tier 9
        ////////////////////////////
        
        cost++;

        const drillDepth8 = this.addNode(new TileRangeSkillNode('drillDepth8', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus8 = this.addNode(new CoolDownSkillNode('drillCool8', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus8 = this.addNode(new DurationSkillNode('drillDur8', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        ////////////////////////////
        // Cost Tier 10
        ////////////////////////////

        cost++;

        const drillDepth9 = this.addNode(new TileRangeSkillNode('drillDepth9', 
            totals, Images.skill.drill, new BigNum(cost), this, Settings.skill.drill.tilesPerUpgrade, this.depthUpgrades, Settings.skill.drill.minRange
        ));

        const coolBonus9 = this.addNode(new CoolDownSkillNode('drillCool9', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.coolDownUpgrades
        ));

        const durationBonus9 = this.addNode(new DurationSkillNode('drillDur9', 
            totals, Images.skill.drill, new BigNum(cost), this, 1, this.durationUpgrades
        ));

        const addMinerNode4 = this.addNode(new AddMinerSkillNode('addDrillMiner4', '+1 Drill Miner', 'Drills straight down', 
            totals, Images.skill.drill, new BigNum(cost + Settings.skill.costs.addMiner4), this, crew, SkillIds.DRILL
        ));

        ///////////////////////////////////
        // Setup node relationships
        ///////////////////////////////////

        addMinerNode1.addChildNode(drillDepth1);
        
        drillDepth1.addChildNode(drillDepth2);
        drillDepth2.addChildNode(drillDepth3);
        drillDepth3.addChildNode(drillDepth4);
        drillDepth4.addChildNode(drillDepth5);
        drillDepth5.addChildNode(drillDepth6);
        drillDepth6.addChildNode(drillDepth7);
        drillDepth7.addChildNode(drillDepth8);
        drillDepth8.addChildNode(drillDepth9);

        drillDepth1.addChildNode(coolBonus1);
        drillDepth2.addChildNode(coolBonus2);
        drillDepth3.addChildNode(coolBonus3);
        drillDepth4.addChildNode(coolBonus4);
        drillDepth5.addChildNode(coolBonus5);
        drillDepth6.addChildNode(coolBonus6);
        drillDepth7.addChildNode(coolBonus7);
        drillDepth8.addChildNode(coolBonus8);
        drillDepth9.addChildNode(coolBonus9);

        drillDepth1.addChildNode(drillDepth2);
        drillDepth2.addChildNode(drillDepth3);
        drillDepth3.addChildNode(drillDepth4);
        drillDepth4.addChildNode(drillDepth5);
        drillDepth5.addChildNode(drillDepth6);
        drillDepth6.addChildNode(drillDepth7);
        drillDepth7.addChildNode(drillDepth8);
        drillDepth8.addChildNode(drillDepth9);

        drillDepth3.addChildNode(addMinerNode2);
        drillDepth6.addChildNode(addMinerNode3);
        drillDepth9.addChildNode(addMinerNode4);

        coolBonus1.addChildNode(durationBonus1);
        coolBonus2.addChildNode(durationBonus2);
        coolBonus3.addChildNode(durationBonus3);
        coolBonus4.addChildNode(durationBonus4);
        coolBonus5.addChildNode(durationBonus5);
        coolBonus6.addChildNode(durationBonus6);
        coolBonus7.addChildNode(durationBonus7);
        coolBonus8.addChildNode(durationBonus8);
        coolBonus9.addChildNode(durationBonus9);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = 3;
        const startY = 13;

        addMinerNode1.setPosition(startX, startY);

        drillDepth1.setPosition(startX + 1, startY);
        drillDepth2.setPosition(startX + 2, startY);
        drillDepth3.setPosition(startX + 3, startY);
        drillDepth4.setPosition(startX + 4, startY);
        drillDepth5.setPosition(startX + 5, startY);
        drillDepth6.setPosition(startX + 6, startY);
        drillDepth7.setPosition(startX + 7, startY);
        drillDepth8.setPosition(startX + 8, startY);
        drillDepth9.setPosition(startX + 9, startY);

        coolBonus1.setPosition(startX + 1, startY - 1);
        coolBonus2.setPosition(startX + 2, startY - 1);
        coolBonus3.setPosition(startX + 3, startY - 1);
        coolBonus4.setPosition(startX + 4, startY - 1);
        coolBonus5.setPosition(startX + 5, startY - 1);
        coolBonus6.setPosition(startX + 6, startY - 1);
        coolBonus7.setPosition(startX + 7, startY - 1);
        coolBonus8.setPosition(startX + 8, startY - 1);
        coolBonus9.setPosition(startX + 9, startY - 1);

        durationBonus1.setPosition(startX + 1, startY - 2);
        durationBonus2.setPosition(startX + 2, startY - 2);
        durationBonus3.setPosition(startX + 3, startY - 2);
        durationBonus4.setPosition(startX + 4, startY - 2);
        durationBonus5.setPosition(startX + 5, startY - 2);
        durationBonus6.setPosition(startX + 6, startY - 2);
        durationBonus7.setPosition(startX + 7, startY - 2);
        durationBonus8.setPosition(startX + 8, startY - 2);
        durationBonus9.setPosition(startX + 9, startY - 2);

        addMinerNode2.setPosition(startX + 3, startY + 1); // below drillDepth3
        addMinerNode3.setPosition(startX + 6, startY + 1); // below drillDepth6
        addMinerNode4.setPosition(startX + 9, startY + 1); // below drillDepth9
    }

    /**
     * @override
     * @param {PartyCharacter} miner
     * @param {number} frameTimeRatio 
     * @param {boolean} skillActive
     */
    updateSkillForFrame(miner, frameTimeRatio, skillActive) {
        /**
         * @type {Drill}
         */
        let drill = this.drillByCharacter[miner.id];
        if (!drill) {
            drill = new Drill(this.worldGrid, this.tileMinedLogic, this.depthUpgrades);
            this.drillByCharacter[miner.id] = drill;
            this.drillArray.push(drill);
        }

        if (skillActive && !drill.skillActive) {
            drill.onSkillActivation();
        }
        else if (!skillActive && drill.skillActive) {
            drill.onSkillDeactivation();
        }

        if (skillActive) {
            drill.updateForFrame(miner, frameTimeRatio);
        }
    }

    /**
     * @override
     * @returns {SkillRenderer}
     */
    getRenderer() {
        return this.renderer;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        super.resetFull();

        this.drillArray.length = 0;
        this.drillByCharacter = {};

        this.depthUpgrades.reset();
    }
}